import React from 'react';
import { IconButton } from '@mui/material';

interface Props {
  url: string;
  children: React.ReactNode;
}

const TitleDetailsPageLink: React.FC<Props> = ({ url, children }) => {
  return (
    <IconButton className="link" onClick={() => window.open(url, '_blank')}>
      {children}
    </IconButton>
  );
};

export default TitleDetailsPageLink;
